export function hardBreak() {
	return { type: 'break' as const };
}
